export const imgText = [
    {
        id: 0,
        title: "Board Games",
        src: "/images/chess.jpeg",
        desc:
            "We want to offer activities everyone can enjoy when then try out items on our menu so we had a few of our employees donate some of their favorite board games which include: ",
        items: [
            "Chess",
            "Checkers",
            "Connect 4",
            "Scrabble",
            "Monopoly",
            "Battleship",
            "Cards Against Humanity",
            "Jenga",
            "Uno",
        ],
    },
    {
        id: 1,
        title: "Gaming Cafe",
        src: "/images/pc cafe.jpeg",
        desc:
            "We personlly love gaming so next door we offer a Gaming cafe that has up to 20 high-end PCs to use hourly. The PCs are decked out with the most recent graphics cards and best gaming peripherals for your enjoyment. Games on the PCs will have: ",
        items: [
            "League of Legends",
            "Valorant",
            "Teamfight Tactics",
            "CS:GO",
            "Dota 2",
            "Overwatch",
            "Apex Legends",
            "Fortnight",
            "And many more and you are welcome to install any we don't have.",
        ],
    },
];
